import { Slider } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

interface ProjectSliderProps {
  value: number;
  max?: number;
  min?: number;
  step?: number;
  isValueInput?: boolean;
  onChange?: (value: number) => void;
  disabled?: boolean;
}

function ProjectSlider({
  value,
  max = 100,
  min = 0,
  step = 1,
  isValueInput = false,
  onChange,
  disabled = false,
}: ProjectSliderProps) {
  const [sliderValue, setSliderValue] = useState<number>(value);
  const [inputValue, setInputValue] = useState<string>(String(value));

  useEffect(() => {
    if (value !== sliderValue) {
      setSliderValue(Number(value));
      setInputValue(String(value));
    }
  }, [value]);

  const handleChange = (_: React.ChangeEvent<{}>, value: number | number[]) => {
    setSliderValue(Number(value));
    setInputValue(String(value));
  };

  const handleChangeCommitted = (_: React.ChangeEvent<{}>, value: number | number[]) => {
    !!onChange && onChange(Number(value));
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value.match(/^-?\d*\.?\d{0,3}$/);

    if (!newValue) return;

    setInputValue(newValue[0] || '');
    setSliderValue(Number(newValue[0]));
    !!onChange && onChange(Number(newValue[0]));
  };

  return (
    <StyledProjectSlider $disabled={disabled}>
      <div className="projectSlider__slider">
        <StyledHalfCircle className="left" $position="left" />
        <StyledHalfCircle className="right" $position="right" />
        <Slider
          value={sliderValue}
          max={max}
          min={min}
          step={step}
          onChange={handleChange}
          onChangeCommitted={handleChangeCommitted}
          disabled={disabled}
        />
      </div>
      {isValueInput && (
        <input className="projectSlider__input" value={inputValue} onChange={handleInputChange} />
      )}
    </StyledProjectSlider>
  );
}

const StyledProjectSlider = styled.div<{ $disabled: boolean }>`
  width: 100%;
  display: flex;
  column-gap: 30px;
  align-items: center;
  .projectSlider__slider {
    width: 100%;
    position: relative;
    .MuiSlider-root {
      width: calc(100% - 16px);
      transform: translateX(8px);
      display: flex;
      align-items: center;
      .MuiSlider-rail {
        height: 16px;
        /* border-radius: 8px; */
        background-color: #e1e1e1;
      }
      .MuiSlider-track {
        height: 16px;
        /* border-radius: 8px; */
        background: ${({ $disabled }) =>
          $disabled
            ? 'linear-gradient(to right, rgba(0, 0, 0, 0), #E1E1E7)'
            : 'linear-gradient(to right, rgba(0, 0, 0, 0), #00a6e2)'};
      }
      .MuiSlider-thumb {
        width: 16px;
        height: 16px;
        /* border: 2px solid #00a6e2; */
        border: ${({ $disabled }) => ($disabled ? '2px solid #E1E1E7;' : '2px solid #00a6e2;')};
        background-color: white;
        box-shadow: ${({ $disabled }) =>
          $disabled ? 'none' : '0px 0px 2px 8px rgba(0, 166, 226, 0.2) !important'};
        /* box-shadow: 0px 0px 2px 8px rgba(0, 166, 226, 0.2) !important; */
        margin-top: 0px;
        transform: translateX(-3px);
        &:hover,
        &:active,
        &.Mui-focusVisible {
          box-shadow: 0px 0px 2px 8px rgba(0, 166, 226, 0.2) !important;
        }
      }
    }
  }
  .projectSlider__input {
    width: 73px;
    height: 40px;
    padding: 0 10px;
    text-align: center;
    border: 1px solid #e1e1e7;
    border-radius: 10px;
    background-color: #f9f9fb;
    font-size: 20px;
    font-weight: 600;
    color: #222;
  }
`;

const StyledHalfCircle = styled.div<{ $position: 'left' | 'right' | 'bottom' | 'top' }>`
  width: 16px;
  height: 16px;
  /* background-color: #e1e1e1; */
  border-radius: 50%;
  position: absolute;
  background: ${({ $position }) =>
    `linear-gradient(to ${$position}, transparent 50%, #f2f2f2 50%)`};
  &.left {
    left: 0;
    top: 5px;
  }
  &.right {
    right: 0;
    top: 5px;
  }
`;

export default ProjectSlider;
